"use client";

import React, { useEffect, useState } from "react";
import { useParams } from "next/navigation";
import { useAppSelector } from "@/app/lib/hooks";
import { fetchExchangeRate } from "@/utils/currencyUtils";
import { formatMoney } from "@/utils/formatMoney";

/**
 * Un montant EN EUR (tarif en base), affiche dans la devise choisie et au centime pres
 * (CTO, 2026-10-06) : 58,33 € reste 58,33 €, converti au taux de la table Exchange rates.
 * Tant que le taux n'est pas la (devise autre que l'EUR), rien n'est affiche plutot qu'un
 * montant EUR presente comme s'il etait dans une autre devise.
 */
const MoneyFromEur: React.FC<{ eur: number | string | null | undefined }> = ({ eur }) => {
  const { lang } = useParams<{ lang: string }>() || ({} as any);
  const selectedCurrency: string = useAppSelector((s: any) => s?.currencies?.selectedCurrency) || "EUR";
  const [rate, setRate] = useState<number | null>(selectedCurrency === "EUR" ? 1 : null);

  useEffect(() => {
    let alive = true;
    if (selectedCurrency === "EUR") {
      setRate(1);
      return undefined;
    }
    setRate(null);
    fetchExchangeRate("EUR", selectedCurrency).then((r) => {
      if (alive) setRate(typeof r === "number" && r > 0 ? r : null);
    });
    return () => {
      alive = false;
    };
  }, [selectedCurrency]);

  const n = Number(eur);
  if (eur === null || eur === undefined || eur === "" || !Number.isFinite(n) || rate == null) return null;
  return <>{formatMoney(n * rate, selectedCurrency, lang)}</>;
};

export default MoneyFromEur;
